module.exports = __webpack_public_path__ + "static/media/male_toilet.5023694a.svg";